import { map, type OperatorFunction } from 'rxjs';

import { type HttpResponse } from '@angular/common/http';

import { type FileDownload } from '../types';

import { assertPresent } from '../utils/assert-present';
import { getContentDispositionFilename } from '@shared/utils/content-disposition';

export function mapFileDownload(): OperatorFunction<HttpResponse<Blob>, FileDownload> {
  return map((response) => {
    assertPresent(response.body);

    return {
      blob: response.body,
      filename: getContentDispositionFilename(response.headers.get('Content-Disposition')),
    };
  });
}
